import TransactionalMessagesPage from '../pages/dashboard/components/pages/transactional/TransactionalMessagesPage';
export default function TransactionalMessagesRoute() { return <TransactionalMessagesPage />; }
